module.exports = __webpack_public_path__ + "static/img/loginBg.fdfb0f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loginBg.jpg
// module id = NR7s
// module chunks = 6